import type { Fund } from '@diggens/types';
import { getPreviousPeriod } from '@diggens/shared-hooks';
import { SET_UP_FUND_PROMPT } from '../../constants/prompts';

export interface ExamplePrompt {
  title: string;
  prompt: string;
}

/** Four things the Manager does on request, asking about the period the firm's first scheduled fund reports on. */
export function examplePrompts(funds: Array<Pick<Fund, 'reporting_frequency' | 'reporting_timezone'>>): ExamplePrompt[] {
  const scheduled = funds.find((fund) => fund.reporting_frequency);
  const period = scheduled?.reporting_frequency ? getPreviousPeriod(scheduled.reporting_frequency, scheduled.reporting_timezone || 'UTC') : null;
  return [
    { title: 'Collection status', prompt: period ? `Who has reported for ${period}?` : 'Who has reported for the current period?' },
    { title: 'Set up a fund', prompt: SET_UP_FUND_PROMPT },
    { title: 'Import companies', prompt: 'I want to import portfolio companies' },
    { title: 'Define metrics', prompt: 'I need to define metrics for a fund' },
  ];
}
